// The import card in the platform agent's panel (D12): before a menu import or a copy runs, while it runs, and how it
// ended. Wording from the Amigo for menus design's copy sheet (Import card, Not live yet, Buttons, Importing, Failed,
// What to try, the 5 reasons, Went live, Import done).
export default {
  title: {
    import: 'Importă meniul de la {{platform}}',
    copy: 'Copiază meniul de la {{restaurant}}',
    data: 'Creați meniul citit de Amigo',
  },
  // A menu Amigo read from a file or the chat (QA36): a change card with each dish, before it is created.
  contents: {
    title: 'Creează {{categories}} și {{dishes}}',
    from: {
      file: 'Amigo a citit aceasta din fișierul tău',
      chat: 'Amigo a citit aceasta din conversația noastră',
    },
    summary:
      'Creează {{categories}} și {{dishes}}. Verifică fiecare preparat împreună cu prețul său în lista de mai jos.',
    price: 'Preț',
    tax_category: 'Categorie fiscală',
    no_price: 'Încă fără preț',
    default_tax: 'Cota ta standard',
    // Once approved: the import's run, in the words of creating a menu.
    creating: 'Se creează {{categories}} și {{dishes}}…',
    done: 'Meniul este creat: {{categories}}, {{dishes}} și {{option_groups}} sunt în meniul restaurantului {{restaurant}}',
    done_plain: 'Meniul este creat',
  },
  waiting: 'În așteptarea aprobării',
  labels: {
    from: 'De la',
    to: 'Către',
    menu: 'Meniu',
    brings_over: 'Preia',
  },
  from: {
    // "Lieferando · lieferando.de/speisekarte/pizzeria-lupo-koeln"
    platform: '{{platform}} · {{link}}',
    // "Pizzeria Lupo · 12 categories, 140 dishes"
    restaurant: '{{restaurant}} · {{categories}}, {{dishes}}',
    // "The menu Amigo read · 2 categories, 4 dishes" (B19)
    data: 'Meniul citit de Amigo · {{categories}}, {{dishes}}',
  },
  to: {
    only_location: '{{name}}, singura sa locație',
    brand_one: 'Meniul brandului {{name}}, singura sa locație',
    brand_few: 'Meniul brandului {{name}}, toate cele {{count}} locații',
    brand_other: 'Meniul brandului {{name}}, toate cele {{count}} de locații',
  },
  menu: {
    empty: 'Gol, deci acesta devine meniul',
    adds: 'Se adaugă la meniul curent ({{size}}). Preparatele cu același nume sunt actualizate; nu se șterge nimic.',
    // The menu's name and size: "Speisekarte: 12 categories, 140 dishes".
    size_named: '{{name}}: {{categories}}, {{dishes}}',
    size: '{{categories}}, {{dishes}}',
  },
  counts: {
    categories_one: '{{count}} categorie',
    categories_few: '{{count}} categorii',
    categories_other: '{{count}} de categorii',
    dishes_one: '{{count}} preparat',
    dishes_few: '{{count}} preparate',
    dishes_other: '{{count}} de preparate',
    option_groups_one: '{{count}} grup de opțiuni',
    option_groups_few: '{{count}} grupuri de opțiuni',
    option_groups_other: '{{count}} de grupuri de opțiuni',
  },
  // What an import brings over, as one list: "Categories, dishes, prices, option groups, photos, and allergens and
  // nutrition where Lieferando has them". Each item starts lowercase; the list's first letter is capitalised.
  brings_over: {
    everything: 'Totul, așa cum este',
    categories: 'categorii',
    dishes: 'preparate',
    descriptions: 'descrieri',
    prices: 'prețuri',
    option_groups: 'grupuri de opțiuni',
    photos: 'fotografii',
    where: {
      allergens_nutrition: 'alergeni și valori nutriționale, acolo unde le are {{platform}}',
      allergens: 'alergeni, acolo unde îi are {{platform}}',
      nutrition: 'valori nutriționale, acolo unde le are {{platform}}',
    },
  },
  not_live: '{{restaurant}} nu este încă activ: clienții pot vedea meniul pe linkul magazinului, dar nu pot comanda.',
  buttons: {
    import: 'Importă',
    copy: 'Copiază',
    cancel: 'Anulează',
  },
  hint: 'Sau răspunde mai jos pentru a schimba ceva.',
  action_failed: 'Nu a funcționat, deci nimic nu s-a schimbat. Încearcă din nou în scurt timp.',
  // Shop's 409 codes when Import is pressed again while the first one runs (QA125).
  refused: {
    already_running: 'Acest import rulează deja. Amigo te anunță aici când este gata.',
    already_applying: 'Se aplică chiar acum. Așteaptă un moment până se termină.',
  },
  importing: {
    title: {
      import: 'Se importă de la {{platform}}…',
      copy: 'Se copiază de la {{restaurant}}…',
    },
    started: 'Început {{time}}',
    queued: 'Se pornește…',
    hint: 'Poate dura câteva minute. Poți închide panoul sau continua să lucrezi; voi publica rezultatul aici.',
  },
  done: {
    // What is on the menu now, while the card is the only result ({{categories}} … are `counts`): "The import from
    // Lieferando is done: 12 categories, 140 dishes and 38 option groups are on Pizzeria Lupo's menu".
    title: {
      import:
        'Importul din {{platform}} s-a încheiat: {{categories}}, {{dishes}} și {{option_groups}} sunt în meniul {{restaurant}}',
      copy: 'Copierea s-a încheiat: {{categories}}, {{dishes}} și {{option_groups}} sunt în meniu',
    },
    // Without counts, or once Amigo's result under the card says them.
    title_plain: {
      import: 'Importul de la {{platform}} este finalizat',
      copy: 'Copierea este finalizată',
    },
    finished: 'Finalizat {{time}}',
    // The page in the sidebar's words: "Open Menu → Manage menus".
    open: 'Deschide {{page}}',
  },
  failed: {
    title: {
      import: 'Nu s-a putut importa: {{reason}}',
      copy: 'Nu s-a putut copia: {{reason}}',
    },
    title_plain: {
      import: 'Nu s-a putut importa',
      copy: 'Nu s-a putut copia',
    },
    nothing: {
      import: 'Nu s-a importat nimic.',
      copy: 'Nu s-a copiat nimic.',
    },
    what_to_try: 'Ce poți încerca:',
    retry: 'Încearcă din nou',
    reasons: {
      listing_not_found: {
        title: 'listarea nu a fost găsită',
        text: '{{platform}} nu are niciun restaurant la acest link. Nu s-a importat nimic.',
        try: 'Deschide linkul într-un browser pentru a verifica dacă afișează meniul restaurantului, apoi trimite-l din nou.',
      },
      listing_not_supported: {
        title: 'listarea nu este acceptată',
        text: 'Aceasta este o pagină de lanț {{platform}}, nu meniul unui singur restaurant, așa că nu o pot importa. Nu s-a importat nimic.',
        try: 'Trimite linkul către pagina de meniu proprie a restaurantului pe {{platform}}.',
      },
      platform_failed: {
        title: '{{platform}} a eșuat',
        text: '{{platform}} nu a răspuns, deci nu s-a importat nimic.',
        try: 'Încearcă din nou peste câteva minute.',
      },
      // A copy from another restaurant that failed on our side: there is no platform to name.
      copy_failed: {
        title: 'copierea a eșuat',
        text: 'Copierea nu s-a finalizat, deci nu s-a copiat nimic.',
        try: 'Încearcă din nou peste câteva minute.',
      },
      // {{listing}} and {{currency}} are currencies with their sign: "British pounds (£)", "euros (€)". {{page}} is the
      // sidebar's My info.
      currency_mismatch: {
        title: 'moneda nu se potrivește',
        text: 'Listarea este în {{listing}}, dar {{restaurant}} folosește {{currency}}. Nu s-a importat nimic.',
        try: 'Trimite o listare în {{currency}} sau verifică mai întâi moneda restaurantului în {{page}}.',
        text_other: 'Listarea este într-o altă monedă decât cea a {{restaurant}}. Nu s-a importat nimic.',
        try_other: 'Trimite o listare în moneda restaurantului sau verifică mai întâi moneda în {{page}}.',
      },
      link_paused: {
        title: 'link în pauză',
        text: 'Acest link a eșuat de 3 ori la rând, deci importurile din el sunt în pauză până la {{time}}. Nu s-a importat nimic.',
        text_no_until:
          'Acest link a eșuat de 3 ori la rând, deci importurile din el sunt momentan în pauză. Nu s-a importat nimic.',
        try: 'Trimite un link de la altă platformă sau copiază meniul de la alt restaurant.',
      },
    },
  },
  stopped: {
    title: 'Oprit: {{restaurant}} a devenit activ',
    nothing: {
      import: 'Nu s-a importat nimic',
      copy: 'Nu s-a copiat nimic',
    },
  },
  // The card folded to one line.
  line: {
    cancelled: 'Anulat',
    expired: 'Expirat',
    replaced: 'Înlocuit',
  },
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Aprobat.',
    cancelled: 'Anulat.',
    retried: 'Încercat din nou.',
  },
};
